var _rect, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11.4286,
    fill: "#323644"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9963 14.1185C14.3147 13.7939 14.7572 13.6171 15.2263 13.6269C15.6954 13.6368 16.1528 13.8325 16.4978 14.171L20.4 17.9998L24.0022 14.3285C24.3207 14.0039 24.7631 13.8271 25.2322 13.8369C25.7014 13.8468 26.1587 14.0425 26.5037 14.381C26.8487 14.7195 27.053 15.173 27.0718 15.6419C27.0905 16.1107 26.9222 16.5564 26.6037 16.881L23.0015 20.5523L26.9037 24.3811C27.2487 24.7196 27.453 25.1732 27.4718 25.642C27.4905 26.1109 27.3222 26.5566 27.0037 26.8812C26.6852 27.2057 26.2428 27.3825 25.7737 27.3727C25.3045 27.3628 24.8472 27.1671 24.5022 26.8287L20.6 22.9998L16.9978 26.6712C16.6793 26.9957 16.2368 27.1725 15.7677 27.1627C15.2986 27.1528 14.8412 26.9571 14.4963 26.6186C14.1513 26.2802 13.9469 25.8266 13.9282 25.3578C13.9094 24.8889 14.0778 24.4432 14.3963 24.1186L17.9985 20.4473L14.0963 16.6185C13.7513 16.28 13.5469 15.8265 13.5282 15.3576C13.5094 14.8888 13.6778 14.443 13.9963 14.1185V14.1185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(7.72351 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.32ae1d03ee662b6e7d124e30eb67569a.svg";
export { ForwardRef as ReactComponent };